var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4168 10C17.4168 14.37 13.8702 17.9167 9.50016 17.9167C5.13016 17.9167 2.46225 13.515 2.46225 13.515M2.46225 13.515H6.04058M2.46225 13.515V17.4734M1.5835 10C1.5835 5.63004 5.0985 2.08337 9.50016 2.08337C14.7806 2.08337 17.4168 6.48504 17.4168 6.48504M17.4168 6.48504V2.52671M17.4168 6.48504H13.9018",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.b3192b372db4e76a49b30e0a89b89bae.svg";
export { ForwardRef as ReactComponent };